import { styled } from '@mui/material/styles';
import { applicationSidePaddingPx } from 'core/theme/constants';
import { AdditionalProps } from './types';

export const ContentBlockStyled = styled('div')<AdditionalProps>`
  width: calc(100% + ${applicationSidePaddingPx * 2}px);
  height: 100%;
  margin-top: 28px;
  margin-bottom: ${({ gutterBottom }) => (gutterBottom ? 'auto' : 0)};
  margin-inline-start: -${applicationSidePaddingPx}px;
  padding: 0;
  padding: 24px ${applicationSidePaddingPx}px 16px;
  border-radius: 16px 16px 0 0;
  background-color: ${({ theme }) => theme.palette.contentBlockBackground.secondary};
`;
